export default "__VITE_ASSET__BKhSoofZ__"